export default {
  'resultandsuccess.success.title': '提交成功',
  'resultandsuccess.success.description':
    '提交結果頁用於反饋壹系列操作任務的處理結果， 如果僅是簡單操作，使用 Message 全局提示反饋即可。 本文字區域可以展示簡單的補充說明，如果有類似展示 “單據”的需求，下面這個灰色區域可以呈現比較復雜的內容。',
  'resultandsuccess.success.operate-title': '項目名稱',
  'resultandsuccess.success.operate-id': '項目 ID',
  'resultandsuccess.success.principal': '負責人',
  'resultandsuccess.success.operate-time': '生效時間',
  'resultandsuccess.success.step1-title': '創建項目',
  'resultandsuccess.success.step1-operator': '曲麗麗',
  'resultandsuccess.success.step2-title': '部門初審',
  'resultandsuccess.success.step2-operator': '周毛毛',
  'resultandsuccess.success.step2-extra': '催壹下',
  'resultandsuccess.success.step3-title': '財務復核',
  'resultandsuccess.success.step4-title': '完成',
  'resultandsuccess.success.btn-return': '返回列表',
  'resultandsuccess.success.btn-project': '查看項目',
  'resultandsuccess.success.btn-print': '打印',
};
